module.exports = __webpack_public_path__ + "static/media/sms.77208c51.svg";